import script from "./ProjectsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsPage.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsPage.vue?vue&type=style&index=0&id=3ff03311&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ff03311"]])

export default __exports__